import { fromJS } from "immutable";
import Label from "~/records/record.label.jsx";
import LabelMap from "~/records/record.label_map.jsx";
import {
  FETCH_LABELS_SUCCESS,
  FETCH_TASKS_SUCCESS,
  ADD_LABEL_SUCCESS,
  ADD_TASK_SUCCESS,
  EDIT_TASK_SUCCESS,
  BATCH_EDIT_TASKS_SUCCESS,
  ANGULAR_INITIALIZE_TASKS,
  ANGULAR_INIT_PROJECT_MODAL,
  ANGULAR_INIT_OTHER,
  ADD_TASK_DEPENDENCIES_SUCCESS,
  FETCH_TASK_DEPENDENCIES_SUCCESS,
  LOAD_TASK,
  FETCH_ACTIVITY_LOGS_SUCCESS,
  EDIT_LABEL_SUCCESS,
  DELETE_LABEL_SUCCESS,
  DELETE_LABEL_LOADING,
  ADD_LABEL_FROM_EVENT_STREAM,
  UPDATE_LABEL_FROM_EVENT_STREAM,
  DELETE_LABEL_FROM_EVENT_STREAM,
  UPDATE_TASK_FROM_EVENT_STREAM,
  PROJECT_TEMPLATE_APPLY_SUCCESS,
} from "~/store/action_types";

export const label = (state = new Label(), action) => {
  switch (action.type) {
    case ADD_LABEL_SUCCESS: {
      const { response = {} } = action;
      const { entities = {}, result = {} } = response;
      const { labels = {} } = entities;
      const { single: labelId } = result;
      const data = labels[`${labelId}`] || {};

      return new Label(
        fromJS({
          ...state.toObject(),
          ...data,
        })
      );
    }
    case ADD_LABEL_FROM_EVENT_STREAM:
    case UPDATE_LABEL_FROM_EVENT_STREAM: {
      const { response = {} } = action;
      const { entities = {}, result: labelId } = response;
      const { labels = {} } = entities;
      const data = labels[`${labelId}`] || {};

      return new Label(
        fromJS({
          ...state.toObject(),
          ...data,
        })
      );
    }
    default:
      return state;
  }
};

const mergeEntities = (state, newLabels) => {
  newLabels.forEach((label) => {
    const id = label.get(`id`);
    const prev = state.get(`${id}`) ?? new Label();

    state = state.set(
      `${id}`,
      new Label({
        ...prev.toObject(),
        ...label.toObject(),
      })
    );
  });

  return state;
};

const labels = (state = new LabelMap(), action) => {
  switch (action.type) {
    case FETCH_LABELS_SUCCESS:
      if (!action.response || !action.response.entities || !action.response.entities.labels) {
        return state;
      }
      return mergeEntities(state, fromJS(action.response.entities.labels));
    case ANGULAR_INITIALIZE_TASKS:
      if (action.response && action.response.entities && action.response.entities.task_labels) {
        return mergeEntities(state, fromJS(action.response.entities.task_labels));
      } else if (action.response && action.response.entities && action.response.entities.project_labels) {
        return mergeEntities(state, fromJS(action.response.entities.project_labels));
      }
      return state;
    case ANGULAR_INIT_OTHER:
    case FETCH_ACTIVITY_LOGS_SUCCESS:
      if (!action.response || !action.response.entities || !action.response.entities.labels) {
        return state;
      }
      return mergeEntities(state, fromJS(action.response.entities.labels));
    case LOAD_TASK:
    case FETCH_TASKS_SUCCESS: {
      const { response = {} } = action;
      const { entities = {} } = response;
      const { labels = {} } = entities;

      Object.values(labels).forEach((label) => {
        let prev = state.get(`${label.id}`);

        if (!prev) {
          prev = new Label();
        }

        state = state.set(
          `${label.id}`,
          new Label({
            ...prev.toObject(),
            ...label,
            class: `TaskLabel`,
          })
        );
      });

      return state;
    }
    case FETCH_TASK_DEPENDENCIES_SUCCESS:
    case ADD_TASK_SUCCESS:
    case ADD_TASK_DEPENDENCIES_SUCCESS:
    case EDIT_TASK_SUCCESS:
    case ANGULAR_INIT_PROJECT_MODAL:
    case BATCH_EDIT_TASKS_SUCCESS:
    case UPDATE_TASK_FROM_EVENT_STREAM:
    case PROJECT_TEMPLATE_APPLY_SUCCESS:
      if (!action.response || !action.response.entities || !action.response.entities.labels) {
        return state;
      }
      return mergeEntities(
        state,
        fromJS(action.response.entities.labels).map((l) => {
          return l.set(`class`, `TaskLabel`);
        })
      );
    case ADD_LABEL_SUCCESS: {
      const { response = {} } = action;
      const { result = {} } = response;
      const { single: labelId } = result;

      return state.set(`${labelId}`, label(state.get(`${labelId}`), action));
    }
    case EDIT_LABEL_SUCCESS: {
      const { response = {} } = action;
      const { entities = {} } = response;
      const { labels = {} } = entities;
      return mergeEntities(state, fromJS(labels));
    }
    case DELETE_LABEL_LOADING:
    case DELETE_LABEL_SUCCESS: {
      const { id } = action;
      if (state.get(`${id}`)) {
        return state.remove(`${id}`);
      }
      return state;
    }
    case DELETE_LABEL_FROM_EVENT_STREAM: {
      const { response } = action;
      const { result: labelId } = response;

      if (state.get(`${labelId}`)) {
        return state.remove(`${labelId}`);
      }
      return state;
    }
    case ADD_LABEL_FROM_EVENT_STREAM:
    case UPDATE_LABEL_FROM_EVENT_STREAM: {
      const { response = {} } = action;
      const { result: labelId } = response;

      return state.set(`${labelId}`, label(state.get(`${labelId}`), action));
    }
    default:
      return state;
  }
};

export default labels;
